import formatDate from "./format-date"

function getCurrentDateFormated(){
    return formatDate(new Date())
}

export default getCurrentDateFormated